import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/base/sheet";

import { BillingTab } from "./BillingTab";

/**
 * The full billing panel — current state and the event log — in the overlay
 * that replaced its tab.
 *
 * Wider than the other sheets: the panel lays its fields out in a four-column
 * grid and pages an event table, neither of which survives 563px.
 */
export function BillingSheet({
  open,
  onOpenChange,
  businessId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessId: string;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full gap-0 p-0 sm:max-w-3xl">
        <SheetHeader className="border-border border-b px-6 py-4">
          <SheetTitle className="text-foreground text-lg font-semibold">
            Billing
          </SheetTitle>
        </SheetHeader>

        <div className="overflow-y-auto p-6">
          {/* Mounted only while open, so its reads happen on demand. */}
          {open && <BillingTab businessId={businessId} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
